var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "查看详情" } }),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("div", { staticClass: "topBox" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm._f("isType")(_vm.systemMessage.type)) +
                " "
            ),
            _c("span", [
              _vm._v(_vm._s(_vm._f("time")(_vm.systemMessage.createTime)))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.name) +
                _vm._s(_vm.systemMessage.content) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _vm.systemMessage.url
            ? _c(
                "a",
                {
                  staticClass: "bottomBox",
                  attrs: { href: _vm.systemMessage.url, target: "_blank" }
                },
                [_vm._v("点击查看详情")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7d066a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7d066a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/serviceAssistantDetail.vue
// module id = null
// module chunks = 